<style lang="scss">
  @use "../../assets/css/design-system/colors";
  @use "../../assets/css/design-system/mixins";

  .link {
    &:hover {
      cursor: pointer;
    }

    &.black {
      @include colors.color(black_90);

      &:hover {
        @include colors.color(primary_50);
      }
    }

    &.blue {
      @include colors.color(primary_50);

      &:hover {
        @include colors.color(primary_70);
      }
    }

    &.extra-small {
      @include mixins.body4();
    }

    &.small {
      @include mixins.caption();
    }

    &.large {
      @include mixins.body2();
    }
  }
</style>

<script>
  /** @type {size?: "large" | "small" | "extra-small"; kind?: "black" | "blue";} */
  let {
    size = "large",
    kind = "blue",
    style = "",
    onclick = () => {},
    href,
    target,
    rel,
    children,
  } = $props();
</script>

<a class="link {size} {kind}" {onclick} {href} {target} {rel} {style}>
  {@render children?.()}
</a>
